<script>
import { computed } from 'vue';
import taggingMixin from '../../lib/tagging/mixin';
import { commonProps, taggingProps } from './prop-definitions';

const props = {
  ...commonProps,
  ...taggingProps,
};

export default {
  name: 'refapp-banner-provider',
  mixins: [taggingMixin],
  provide() {
    return Object.keys(props).reduce((acc, curr) => {
      acc[curr] = computed(() => this[curr]);
      return acc;
    }, {});
  },
  props,
  render() {
    const isVue3Slot = this.$slots.default instanceof Function;

    if (isVue3Slot) {
      return this.$slots.default();
    }

    return this.$slots.default;
  },
};
</script>
